import React, { createContext, useContext, useState } from 'react';


const AppDataContext = createContext();

export const AppDataProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState({}); // Initialize your data here
  const [userBanks, setUserBanks] = useState({}); // Initialize your data here
  const [cryptoSecret, setCryptoSecret] = useState(null); // Initialize your data here
  const [razorKey, setRazorKey] = useState(null); // Initialize your data here
  const [userFnYear, setUserFnYear] = useState([]);  // Initialize your data here
  const [selectedYear, setSelectedYear] = useState([]);
  const [withdrawinfo, setWithdrawinfo] = useState({});  // Initialize your data here
  const [showModal, updateShowModal] = React.useState(false);
  const [margindata, setMarginData ] =useState({});
  const [expandedItem, setExpandedItem] = useState(null) // srini - 30-05-25
  return (
    <AppDataContext.Provider value={{ 
      userInfo, setUserInfo, 
      userBanks, setUserBanks, 
      razorKey, setRazorKey, 
      cryptoSecret, setCryptoSecret, 
      userFnYear, setUserFnYear, 
      selectedYear, setSelectedYear ,
      withdrawinfo, setWithdrawinfo ,
      showModal, updateShowModal,
      margindata, setMarginData,
      expandedItem, setExpandedItem // srini - 30-05-25
      }}>
      {children}
    </AppDataContext.Provider>
  );
};

export const useAppData = () => useContext(AppDataContext);
